import React, { Component } from 'react'
import {Row, Col} from 'react-flexbox-grid'
import CSSModules from 'react-css-modules'
import Styles from './TobaccoSectors.css'
import {Link, SrOnly} from '..'
import config from '../../config'

@CSSModules(Styles)
export default class TobaccoSectors extends Component {
  static propTypes = {
  }
  constructor(props){
    super(props);
  }
  render() {
    const toIcon = require( '../../../static/images/icon-cigarette.svg' )
    const tmIcon = require( '../../../static/images/icon-cinema.svg' )

    return (
      <div styleName='sectors-wrap'>
        <div styleName='sectors'>
          <div styleName='sectors-inner'>
            <Row>
              <Col xs={12} sm={6} styleName='detail-tobacco-wrapper'>
                <div styleName='detail-to'>
                  <img styleName='detail-icon' src={toIcon} alt='Multi-national tobacco companies'/>
                  <div styleName='detail-title'>Multi-national tobacco companies</div>
                  <div styleName='detail-stat'>
                    Tobacco is the #1 cause of preventable death in the U.S. and <strong><em>one billion lives</em></strong> are at stake worldwide. Around the world, 180 countries have ratified the <Link to={config.links.who} xstrong={true} title='World Health Organization Framework Convention on Tobacco Control'>World Health Organization Framework Convention on Tobacco Control.</Link>
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={6} styleName='detail-movies-wrapper'>
                <div styleName='detail-tm'>
                  <img styleName='detail-icon' src={tmIcon} alt='Tobacco-promoting entertainment companies'/>
                  <div styleName='detail-title'>Tobacco-promoting entertainment companies</div>
                  <div styleName='detail-stat'><Link to={config.links.nytarticle} xstrong={true} title='New York Times: Why Smoking in Films Harms Children'>Making kid-rated movies smokefree</Link> would prevent one million tobacco deaths in this generation of U.S. kids. Hollywood studios and their parent companies are well aware of the public health risk, but continue to expose millions of kids to tobacco.</div>
                </div>
              </Col>
            </Row>
            <div styleName='sectors-didyouknow'>
              <div styleName='stat'>
                <div styleName='stat-label'>Did you know </div>
                <div styleName='stat-count-wrapper'>
                  <div styleName='stat-count'><i styleName='fa-question'></i></div>
                </div>
              </div>
              <div styleName='sectors-didyouknow-info'>Around the world, 180 countries have committed to combat tobacco addiction, disability and early death — and <Link to={config.links.whoPdf} xstrong={true} title='WHO: Guidelines for implementation of Article 13 of the WHO Framework Convention on Tobacco Control (PDF)'>end tobacco promotion through the entertainment media.</Link> <Link to={config.links.reader} strong={true} title='Download Acrobat Reader to view this PDF'><i className='fa fa-file-pdf-o'></i><SrOnly>Download Acrobat Reader to view this PDF</SrOnly></Link></div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

